import { loadLocalData, saveLocalData } from '@/store/state';
import { setSettings } from '@/store/auth';

const STATE_SETTINGS_KEY = 'settings';

export const loadConfig = _store => {
	return loadLocalData(setSettings, _store, STATE_SETTINGS_KEY).then(() => {
		const config = _store.state.settings.config;
		// for (const key in config) {
		// 	console.log(`load, config.${key}=${config[key]}`);
		// }
		return config ? true : false;
	});
};

export const saveConfig = _store => {
	// const config = _store.state.settings.config;
	// for (const key in config) {
	// 	console.log(`save, config.${key}=${JSON.stringify(config[key])}`);
	// }
	return saveLocalData(STATE_SETTINGS_KEY, _store.state.settings);
};
